(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 8312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(4405);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4405:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./components/DropdownComponent.tsx


const DropdownComponent = (param)=>{
    let { title , value , onChange , options , className  } = param;
    const [isOpen, setIsOpen] = react.useState(false);
    const selectedOption = options === null || options === void 0 ? void 0 : options.find((option)=>option.value === value);
    const selectedLabel = selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.label;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative group z-[999] w-auto",
        tabIndex: 0,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                className: className,
                onClick: ()=>{
                    setIsOpen(!isOpen);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "truncate",
                        children: [
                            title,
                            " ",
                            selectedLabel
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                        "aria-hidden": "true",
                        className: "w-4 h-4 ml-1",
                        fill: "currentColor",
                        viewBox: "0 0 20 20",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                id: "dropdown-nav",
                className: "absolute z-[999] left-0  transition-all bg-white rounded invisible dropdown-custom w-inherit top-full group-focus-within:visible group-focus-within:opacity-100 group-focus-within:translate-y-1 max-h-[250px] scrollbar overflow-y-auto",
                tabIndex: 0,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    className: "py-1",
                    children: options === null || options === void 0 ? void 0 : options.map((option)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            onClick: ()=>{
                                onChange(option.value);
                            },
                            className: "cursor-pointer",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: "block px-4 py-2 m-2 hover:bg-[#4E4964] hover:rounded-lg font-bold text-white",
                                children: option.label
                            })
                        }, option.value))
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/FAQ.tsx


const FAQItem = (param)=>{
    let { question , answer  } = param;
    const [isOpen, setIsOpen] = (0,react.useState)(false);
    const toggleOpen = ()=>{
        setIsOpen(!isOpen);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "border-b border-gray-600 py-4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                onClick: toggleOpen,
                className: "w-full text-left flex justify-between items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-[16px] font-bold text-title",
                        children: question
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "transform ".concat(isOpen ? "rotate-[360deg]" : "rotate-[270deg]", " transition-transform duration-300 text-white"),
                        children: "▼"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "transition-all duration-300 ease-in-out overflow-hidden ".concat(isOpen ? "max-h-[1000px]" : "max-h-0"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "mt-2 text-[#C3BFD9] font-medium",
                    children: answer
                })
            })
        ]
    });
};
const FAQSection = (param)=>{
    let { faqData  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "container mx-auto px-4 py-8 flex flex-col md:justify-center xl:px-[0px] md:mt-[80px] w-full mt-[50px] gap-[20px] xl:gap-[25px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "text-2xl font-bold text-white mb-6 pl-[15px]",
                children: "Frequently Asked Questions"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full h-auto container-background rounded-[16px] pl-[27px] pr-[30px] pt-[21px] pb-[25px]",
                children: faqData.map((faq, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(FAQItem, {
                        question: faq.question,
                        answer: faq.answer
                    }, index))
            })
        ]
    });
};
/* harmony default export */ var FAQ = (FAQSection);

// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 40 modules
var axios = __webpack_require__(8945);
;// CONCATENATED MODULE: ./services/api.ts

// prod: 'https://587ff7jac4.execute-api.us-east-1.amazonaws.com'
const api_api = axios/* default.create */.Z.create({
    baseURL: "https://api.defireturns.com"
});
/* harmony default export */ var services_api = (api_api);

;// CONCATENATED MODULE: ./utils/PostHog.ts
/* Remember that this information will be used by our marketing team to understand how our users are using the app. So please, be in mind that the event names should be human friendly and easy to understand.

  Some rules to follow:
   - Try to add the event in a chronological order (e.g: if you are adding an event that happens after the user clicks on a button, try to add it after the event that happens when the user clicks on the button)
   - Use static methods only
   - Use camelCase for method names
   - Use snake_case for event properties
   - Use past tense for event names
   - Some event names have a through property. This property is used to understand how the user got to that event when there are different ways to achieve the same action. For example, if the user "selected a strategy" after opening a popup, the event "SelectedStrategy" should have a "through" property equals to "Popup". This way, we can understand how the user got to that event.
*/ class PostHogUtils {
    static clickedToAddStrategiesPopup(posthogObj) {
        posthogObj === null || posthogObj === void 0 ? void 0 : posthogObj.capture("Clicked to Open Strategies Popup (Mobile)");
    }
    static selectedStrategy(posthogObj, strategy, selectedStrategyIds, strategies, through) {
        const currentStrategiesName = selectedStrategyIds === null || selectedStrategyIds === void 0 ? void 0 : selectedStrategyIds.map((selectedStrategyId)=>{
            var _strategies_strategies;
            const selectedStrategy = strategies === null || strategies === void 0 ? void 0 : (_strategies_strategies = strategies.strategies) === null || _strategies_strategies === void 0 ? void 0 : _strategies_strategies.items.find((strategy)=>strategy._id === selectedStrategyId);
            return "".concat(selectedStrategy === null || selectedStrategy === void 0 ? void 0 : selectedStrategy.company, " - ").concat(selectedStrategy === null || selectedStrategy === void 0 ? void 0 : selectedStrategy.product);
        });
        const eventPropertiesObject = {
            through,
            strategy_id: strategy._id,
            strategy_company: strategy === null || strategy === void 0 ? void 0 : strategy.company,
            strategy_pool: strategy === null || strategy === void 0 ? void 0 : strategy.pool,
            strategy_product: strategy === null || strategy === void 0 ? void 0 : strategy.product,
            current_strategies: currentStrategiesName
        };
        posthogObj === null || posthogObj === void 0 ? void 0 : posthogObj.capture("Selected a strategy", eventPropertiesObject);
    }
    static unselectedStrategy(posthogObj, strategy, selectedStrategyIds, strategies, through) {
        const currentStrategiesName = selectedStrategyIds === null || selectedStrategyIds === void 0 ? void 0 : selectedStrategyIds.map((selectedStrategyId)=>{
            var _strategies_strategies;
            const selectedStrategy = strategies === null || strategies === void 0 ? void 0 : (_strategies_strategies = strategies.strategies) === null || _strategies_strategies === void 0 ? void 0 : _strategies_strategies.items.find((strategy)=>strategy._id === selectedStrategyId);
            return "".concat(selectedStrategy === null || selectedStrategy === void 0 ? void 0 : selectedStrategy.company, " - ").concat(selectedStrategy === null || selectedStrategy === void 0 ? void 0 : selectedStrategy.product);
        });
        const eventPropertiesObject = {
            through,
            strategy_id: strategy._id,
            strategy_company: strategy === null || strategy === void 0 ? void 0 : strategy.company,
            strategy_pool: strategy === null || strategy === void 0 ? void 0 : strategy.pool,
            strategy_product: strategy === null || strategy === void 0 ? void 0 : strategy.product,
            current_strategies: currentStrategiesName
        };
        posthogObj === null || posthogObj === void 0 ? void 0 : posthogObj.capture("Unselected a strategy", eventPropertiesObject);
    }
    static selectedGranularity(posthogObj, value) {
        posthogObj === null || posthogObj === void 0 ? void 0 : posthogObj.capture("Selected a granularity", {
            granularity: value
        });
    }
    static selectedYieldType(posthogObj, yieldType) {
        posthogObj === null || posthogObj === void 0 ? void 0 : posthogObj.capture("Selected Yield Type", {
            yield_type: yieldType
        });
    }
    static selectedBaseAssetFilter(posthogObj, baseAsset) {
        posthogObj === null || posthogObj === void 0 ? void 0 : posthogObj.capture("Selected Base Asset", {
            base_asset: baseAsset
        });
    }
    static requestedAPIAccess(posthogObj, through) {
        posthogObj === null || posthogObj === void 0 ? void 0 : posthogObj.capture("Requested API Access", {
            through
        });
    }
    static clickedOnDatePicker(posthogObj, through) {
        posthogObj === null || posthogObj === void 0 ? void 0 : posthogObj.capture("Requested API Access", {
            through
        });
    }
    static submittedToNewsletter(posthogObj, email) {
        posthogObj === null || posthogObj === void 0 ? void 0 : posthogObj.capture("Submitted to Newsletter", {
            email
        });
    }
    static submittedToNewsletterSuccess(posthogObj) {
        posthogObj === null || posthogObj === void 0 ? void 0 : posthogObj.capture("Submitted to Newsletter with Success");
    }
    static errorToastClicked(posthogObj, errorMessage) {
        posthogObj === null || posthogObj === void 0 ? void 0 : posthogObj.capture("Clicked on Error Toast", {
            error_message: errorMessage
        });
    }
    static unselectedAllStrategies(posthogObj) {
        posthogObj === null || posthogObj === void 0 ? void 0 : posthogObj.capture("Unselected all strategies");
    }
}

// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/QueryClientProvider.mjs
var QueryClientProvider = __webpack_require__(5945);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useQueries.mjs + 1 modules
var useQueries = __webpack_require__(7669);
// EXTERNAL MODULE: ./node_modules/posthog-js/react/dist/esm/index.js
var esm = __webpack_require__(8192);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.mjs + 1 modules
var react_toastify_esm = __webpack_require__(2920);
;// CONCATENATED MODULE: ./queries/historical/index.ts





async function getHistoricalYield(ctx) {
    const [, strategy, startDate, currency, endDate, includeLatest] = ctx.queryKey;
    const { data  } = await services_api.get("/strategy/".concat(strategy, "/history"), {
        params: {
            startDate,
            endDate,
            includeLatest
        }
    });
    return {
        strategy,
        data
    };
}
function useHistoricalYield(strategies, startDate, currency, endDate, includeLatest) {
    const queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    const posthogInstance = (0,esm/* usePostHog */.U0)();
    return (0,useQueries/* useQueries */.h)({
        queries: strategies.map((strategy)=>{
            return {
                queryKey: [
                    "historicalYield",
                    strategy,
                    startDate,
                    currency,
                    endDate,
                    includeLatest
                ],
                queryFn: (ctx)=>getHistoricalYield(ctx),
                onError: (error)=>{
                    react_toastify_esm/* toast.error */.Am.error("API Fetch error, Click here to try again: \n" + (error === null || error === void 0 ? void 0 : error.toString()), {
                        onClick: ()=>{
                            const queryKey = [
                                "historicalYield",
                                strategy,
                                startDate,
                                currency,
                                endDate,
                                includeLatest
                            ];
                            PostHogUtils.errorToastClicked(posthogInstance, error === null || error === void 0 ? void 0 : error.toString());
                            queryClient.refetchQueries(queryKey);
                        }
                    });
                },
                refetchOnWindowFocus: false,
                refetchOnMount: false
            };
        })
    });
}

;// CONCATENATED MODULE: ./utils/DateUtils.ts
const formatDate = (date)=>{
    return date.toLocaleString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric"
    });
};
const formatDateFromString = (date)=>{
    return new Date(date).toLocaleString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric"
    });
};
const formatYYYYMMDD = (date)=>{
    return date.toISOString().split("T")[0];
};
const today1MonthAgo = ()=>{
    const date = new Date();
    date.setMonth(date.getMonth() - 1);
    return date;
};

// EXTERNAL MODULE: ./node_modules/zustand/esm/index.mjs + 1 modules
var zustand_esm = __webpack_require__(4529);
;// CONCATENATED MODULE: ./stores/historical.ts


const useHistoricalStore = (0,zustand_esm/* create */.Ue)((set)=>({
        startDate: formatYYYYMMDD(today1MonthAgo()),
        endDate: null,
        granularity: "1month",
        startDateFormatted: formatDate(today1MonthAgo()),
        endDateFormatted: null,
        yieldType: "Yield",
        currency: "0x0000000000000000000000000000000000000000",
        setStartDate: (startDate)=>set(()=>({
                    startDate,
                    startDateFormatted: formatDateFromString(startDate)
                })),
        setEndDate: (endDate)=>set(()=>({
                    endDate: endDate === "" ? null : endDate,
                    endDateFormatted: endDate === "" ? null : endDate ? formatDateFromString(endDate) : null
                })),
        setGranularity: (granularity)=>set(()=>({
                    granularity
                })),
        setYieldType: (yieldType)=>set(()=>({
                    yieldType
                })),
        setCurrency: (currency)=>set(()=>({
                    currency
                }))
    }));

;// CONCATENATED MODULE: ./stores/protocols.ts

const useProtocolsStore = (0,zustand_esm/* create */.Ue)((set)=>({
        selectedStrategyIds: [],
        selectedBaseAssets: [],
        search: "",
        skip: "0",
        limit: "100",
        baseAssetFilter: "",
        isProtocolsOpen: true,
        filterBy: "all",
        setFilterBy: (filterBy)=>set({
                filterBy
            }),
        setBaseAssetFilter: (asset)=>set({
                baseAssetFilter: asset
            }),
        unselectAll: ()=>set({
                selectedStrategyIds: []
            }),
        setSearch: (search)=>set({
                search
            }),
        setIsProtocolsOpen: (isOpen)=>set({
                isProtocolsOpen: isOpen
            }),
        setStrategiesId: (id)=>{
            if (!id) return;
            set((state)=>{
                return {
                    selectedStrategyIds: state.selectedStrategyIds.includes(id) ? state.selectedStrategyIds : [
                        ...state.selectedStrategyIds,
                        id
                    ]
                };
            });
        },
        unsetStrategiesId: (id)=>{
            set((state)=>({
                    selectedStrategyIds: state.selectedStrategyIds.filter((strategyId)=>strategyId !== id)
                }));
        }
    }));

;// CONCATENATED MODULE: ./utils/Colors.ts
const highContrastColors = [
    "#8444A4",
    "#4D6DA4",
    "#4A89A4",
    "#4DA4A4",
    "#4EA489",
    "#52A452",
    "#5CA452",
    "#77A452",
    "#A44D6D",
    "#A45252",
    "#A45A4D",
    "#A4774D",
    "#A4A44D",
    "#6DA44D",
    "#4DA452",
    "#52A4A4",
    "#52A4D1",
    "#525CA4",
    "#7B52A4",
    "#A452A4",
    "#D152A4",
    "#FF52A4",
    "#FF5277",
    "#FF5252",
    "#FF7852",
    "#FFA452",
    "#FFD152",
    "#D1FF52",
    "#7BFF52",
    "#52FFA4",
    "#52D1FF",
    "#5289FF",
    "#5252FF",
    "#8952FF",
    "#D152FF",
    "#FF52D1",
    "#A477A4",
    "#A4A4A4",
    "#FFFFFF",
    "#FFFFAA",
    "#FFD1AA",
    "#FFB6AA",
    "#FF9DAA",
    "#FF7EAA",
    "#FF52FF",
    "#FF52B6",
    "#FF52AA",
    "#FF5289",
    "#FF5277",
    "#FF525C",
    "#FF5252",
    "#FF4D4D",
    "#A4524D",
    "#4D52A4",
    "#4D4DA4",
    "#4D6D7B",
    "#4D8E7B",
    "#4DA48F",
    "#4DA4A4",
    "#4D8E4D",
    "#4D7B6D",
    "#4D7B8E",
    "#4D7BA4",
    "#6D4D7B",
    "#8E4D7B",
    "#A44D7B",
    "#FFD1FF",
    "#D1A4FF",
    "#A477FF",
    "#7B52FF",
    "#4D4DFF",
    "#4D7BD1",
    "#4D8ED1",
    "#4DA4D1",
    "#4D8E52",
    "#4D7B52",
    "#4D6D52",
    "#527B4D",
    "#A44D52",
    "#A44D89",
    "#A44DB6"
];
function hexToRGB(hex, alpha) {
    var r = parseInt(hex.slice(1, 3), 16), g = parseInt(hex.slice(3, 5), 16), b = parseInt(hex.slice(5, 7), 16);
    if (alpha) {
        return "rgba(" + r + ", " + g + ", " + b + ", " + alpha + ")";
    } else {
        return "rgb(" + r + ", " + g + ", " + b + ")";
    }
}

// EXTERNAL MODULE: ./node_modules/@heroicons/react/24/solid/esm/ArrowPathIcon.js
var ArrowPathIcon = __webpack_require__(6207);
;// CONCATENATED MODULE: ./components/notifications/LoadingComponent.tsx



const LoadingComponent = (param)=>{
    let { message ="Loading..." , inline =false  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat(inline ? "flex-row gap-4" : "flex-col", " flex items-center justify-center mt-4 text-white"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowPathIcon/* default */.Z, {
                className: "w-12 h-12 animate-spin"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-1xl",
                children: message
            })
        ]
    });
};
/* harmony default export */ var notifications_LoadingComponent = (LoadingComponent);

// EXTERNAL MODULE: ./node_modules/chartjs-plugin-style/dist/chartjs-plugin-style.js
var chartjs_plugin_style = __webpack_require__(4681);
// EXTERNAL MODULE: ./node_modules/react-chartjs-2/es/index.js
var es = __webpack_require__(6799);
;// CONCATENATED MODULE: ./components/LineChart.tsx









const LineChart = (param)=>{
    let { strategies  } = param;
    const { yieldType , startDate , endDate , currency  } = useHistoricalStore((state)=>({
            yieldType: state.yieldType,
            startDate: state.startDate,
            endDate: state.endDate,
            currency: state.currency
        }));
    const { selectedStrategyIds  } = useProtocolsStore((state)=>({
            selectedStrategyIds: state.selectedStrategyIds
        }));
    const historicalYieldData = useHistoricalYield(selectedStrategyIds, startDate, currency, endDate, true);
    const isLoading = historicalYieldData.some((result)=>result.isLoading);
    if (isLoading) return /*#__PURE__*/ (0,jsx_runtime.jsx)(notifications_LoadingComponent, {});
    const graphData = historicalYieldData === null || historicalYieldData === void 0 ? void 0 : historicalYieldData.map((value)=>{
        if (value === null || value === void 0 ? void 0 : value.data) {
            const { strategy , data  } = value.data;
            if (data) {
                return {
                    _id: strategy,
                    labels: data === null || data === void 0 ? void 0 : data.map((v)=>new Date(v.timestamp).valueOf()),
                    data: data === null || data === void 0 ? void 0 : data.map((v)=>{
                        if (yieldType === "Rewards") {
                            return (v.position + v.reward - 1) * 100;
                        }
                        return (v.position - 1) * 100;
                    })
                };
            } else {
                return {
                    _id: "",
                    labels: [],
                    data: []
                };
            }
        } else {
            return {
                _id: "",
                labels: [],
                data: []
            };
        }
    })// sort by the highest value
    .sort((a, b)=>{
        if (a.data && b.data) {
            return b.data[b.data.length - 1] - a.data[a.data.length - 1];
        }
        return 0;
    });
    const datasets = graphData.map((dataset)=>{
        var _strategies_strategies, _strategies_strategies_items, _strategies_strategies1, _strategies_strategies2;
        var _strategies_strategies_items_findIndex;
        const strategyIndex = (_strategies_strategies_items_findIndex = strategies === null || strategies === void 0 ? void 0 : (_strategies_strategies = strategies.strategies) === null || _strategies_strategies === void 0 ? void 0 : (_strategies_strategies_items = _strategies_strategies.items) === null || _strategies_strategies_items === void 0 ? void 0 : _strategies_strategies_items.findIndex((obj)=>obj._id === dataset._id)) !== null && _strategies_strategies_items_findIndex !== void 0 ? _strategies_strategies_items_findIndex : 0;
        const strategy = (strategies === null || strategies === void 0 ? void 0 : (_strategies_strategies1 = strategies.strategies) === null || _strategies_strategies1 === void 0 ? void 0 : _strategies_strategies1.items) && (strategies === null || strategies === void 0 ? void 0 : (_strategies_strategies2 = strategies.strategies) === null || _strategies_strategies2 === void 0 ? void 0 : _strategies_strategies2.items[strategyIndex]);
        var _highContrastColors_strategyIndex;
        const color = (_highContrastColors_strategyIndex = highContrastColors[strategyIndex]) !== null && _highContrastColors_strategyIndex !== void 0 ? _highContrastColors_strategyIndex : "#fff";
        let payloadDataset = {
            label: (strategy === null || strategy === void 0 ? void 0 : strategy.pool) + " - " + (strategy === null || strategy === void 0 ? void 0 : strategy.company) + " - " + (strategy === null || strategy === void 0 ? void 0 : strategy.product),
            fill: false,
            shadowOffsetX: 0,
            shadowOffsetY: 10,
            shadowBlur: 10,
            shadowColor: color,
            backgroundColor: color,
            borderColor: color,
            borderDash: [],
            borderDashOffset: 0.0,
            pointBorderColor: color,
            pointBackgroundColor: color,
            pointBorderWidth: 1,
            pointHoverRadius: 5,
            pointHoverBackgroundColor: color,
            pointHoverBorderColor: color,
            pointHoverBorderWidth: 2,
            pointRadius: 1,
            pointHitRadius: 10,
            data: dataset.data
        };
        // TODO: bring back the shadows at some point
        if (true) {
            payloadDataset.shadowOffsetX = 0;
            payloadDataset.shadowOffsetY = 0;
            payloadDataset.shadowBlur = 0;
            payloadDataset.shadowColor = "rgba(0,0,0,0)";
        }
        return payloadDataset;
    });
    const options = {
        title: {
            display: false
        },
        legend: {
            display: false
        },
        maintainAspectRatio: false,
        responsive: true,
        animation: {
            duration: 0
        },
        hover: {
            animationDuration: 0
        },
        responsiveAnimationDuration: 0,
        tooltips: {
            mode: "index",
            intersect: false,
            custom: function(tooltipModel) {
                // Tooltip Element
                var tooltipEl = document.getElementById("chartjs-tooltip");
                // Create element on first render
                if (!tooltipEl) {
                    tooltipEl = document.createElement("div");
                    tooltipEl.id = "chartjs-tooltip";
                    tooltipEl.style.borderRadius = "10px";
                    document.body.appendChild(tooltipEl);
                }
                // Hide if no tooltip
                if (tooltipModel.opacity === 0) {
                    tooltipEl.style.opacity = "0";
                    return;
                }
                // Set caret Position
                tooltipEl.classList.remove("above", "below", "no-transform");
                if (tooltipModel.yAlign) {
                    tooltipEl.classList.add(tooltipModel.yAlign);
                } else {
                    tooltipEl.classList.add("no-transform");
                }
                function getBody(bodyItem) {
                    return bodyItem.lines;
                }
                // Set Text
                if (tooltipModel.body) {
                    var titleLines = tooltipModel.title || [];
                    var bodyLines = tooltipModel.body.map(getBody);
                    var innerHtml = "<div style='font-style: normal; font-weight: 700; font-size: 12px; line-height: 20px; color: #ffffff;'>";
                    titleLines.forEach(function(title) {
                        innerHtml += "" + title + "";
                    });
                    innerHtml += "</div>";
                    innerHtml += '<div style="margin-top: 9px;">';
                    bodyLines.forEach(function(body, i) {
                        var colors = tooltipModel.labelColors[i];
                        const rgbColor = hexToRGB(colors.backgroundColor.toString(), "0.4");
                        var span = '<div style="display: flex; gap: 5px; margin-top: 14px"><div style="width: 14px; height: 14px; background: '.concat(colors.backgroundColor, "; box-shadow: 2px 3px 6px ").concat(rgbColor, '; border-radius: 3px;"></div>');
                        innerHtml += span + '<div style="color: white">' + body + "</div>" + "</div>";
                    });
                    const tooltip = document.getElementById("chartjs-tooltip");
                    if (tooltip) {
                        tooltip.innerHTML = innerHtml;
                    }
                }
                // `this` will be the overall tooltip
                var position = this._chart.canvas.getBoundingClientRect();
                let positionX = 0;
                const horizontalOffset = 40;
                if (position.left + window.pageXOffset + tooltipModel.caretX + (tooltipModel.width + 2 * horizontalOffset) > position.right) {
                    positionX = position.left + window.pageXOffset + tooltipModel.caretX - (tooltipModel.width / 2 + horizontalOffset);
                } else {
                    positionX = position.left + window.pageXOffset + tooltipModel.caretX + (tooltipModel.width / 2 + horizontalOffset);
                }
                if (positionX < tooltipModel.width / 2) {
                    positionX = position.left + (tooltipModel.width / 2 + horizontalOffset);
                }
                var _window_event_clientY;
                // Mobile offset problem
                const offsetY = (_window_event_clientY = window.event.clientY) !== null && _window_event_clientY !== void 0 ? _window_event_clientY : window.event.touches[0].clientY;
                const positionY = window.pageYOffset + offsetY + 10;
                // Display, position, and set styles for font
                tooltipEl.style.opacity = "1";
                tooltipEl.style.position = "absolute";
                tooltipEl.style.left = positionX + "px";
                tooltipEl.style.top = positionY + "px";
                tooltipEl.style.fontFamily = tooltipModel._bodyFontFamily;
                tooltipEl.style.fontSize = tooltipModel.bodyFontSize + "px";
                tooltipEl.style.fontStyle = tooltipModel._bodyFontStyle;
                tooltipEl.style.borderRadius = "10px";
                tooltipEl.style.padding = "13px";
                tooltipEl.style.pointerEvents = "none";
            },
            enabled: false,
            callbacks: {
                label: function(tooltipItem, data) {
                    var _data_datasets;
                    let label = ((_data_datasets = data.datasets) === null || _data_datasets === void 0 ? void 0 : _data_datasets[tooltipItem.datasetIndex || 0].label) || "";
                    if (label) {
                        label += ": ";
                    }
                    label += parseFloat((tooltipItem.yLabel || 0).toString()).toFixed(2) + "%";
                    return label;
                }
            }
        },
        scales: {
            xAxes: [
                {
                    type: "time",
                    distribution: "linear",
                    scaleLabel: {
                        display: true
                    }
                }
            ],
            yAxes: [
                {
                    ticks: {
                        callback: function(value) {
                            return parseFloat(value.toString()).toFixed(2) + "%";
                        }
                    }
                }
            ]
        }
    };
    const data = {
        labels: graphData[0] ? graphData[0].labels : [],
        datasets
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Line */.x1, {
        data: data,
        height: 470,
        options: options,
        redraw: true
    });
};
/* harmony default export */ var components_LineChart = (LineChart);

// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useQuery.mjs + 1 modules
var useQuery = __webpack_require__(7000);
;// CONCATENATED MODULE: ./queries/protocols/index.ts


async function investmentsData(ctx) {
    const [, skip, limit] = ctx.queryKey;
    const { data  } = await services_api.get("/homepage?skip=".concat(skip, "&limit=").concat(limit));
    return data;
}
function useInvestmentsData(skip) {
    let limit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "100";
    return (0,useQuery/* useQuery */.a)([
        "investmentsData",
        skip,
        limit
    ], investmentsData, {
        refetchOnWindowFocus: false
    });
}
async function getInvestmentsDataSSR() {
    const skip = "0";
    const limit = "100";
    const { data  } = await api.get("/homepage?skip=".concat(skip, "&limit=").concat(limit));
    return data;
}

;// CONCATENATED MODULE: ./stores/modals.ts

const useModalsStore = (0,zustand_esm/* create */.Ue)((set)=>({
        showModalDatePicker: false,
        showModalProtocolsMobile: false,
        showModalRequestAccess: false,
        setShowModalProtocolsMobile: (showModalProtocolsMobile)=>set(()=>({
                    showModalProtocolsMobile
                })),
        setShowModalDatePicker: (showModalDatePicker)=>set(()=>({
                    showModalDatePicker
                })),
        setShowModalRequestAccess: (showModalRequestAccess)=>set(()=>({
                    showModalRequestAccess
                }))
    }));

// EXTERNAL MODULE: ./node_modules/nextjs-google-analytics/dist/index.js
var dist = __webpack_require__(4304);
;// CONCATENATED MODULE: ./utils/GoogleAnalytics.ts


class GoogleAnalytics {
    static downloadCSVClicked() {
        (0,dist/* event */.B)("download_csv", {
            category: "Fake_Doors",
            action: "download_csv"
        });
    }
    static granularityBlocklyClicked() {
        (0,dist/* event */.B)("granularity_blockly", {
            category: "Fake_Doors",
            action: "granularity_blockly"
        });
    }
    static granularityClicked(granularity) {
        (0,dist/* event */.B)("granularity_clicked", {
            category: "General",
            action: "granularity_clicked",
            label: granularity
        });
    }
    static askNewProjectClicked() {
        (0,dist/* event */.B)("ask_new_project", {
            category: "Fake_Doors",
            action: "ask_new_project"
        });
    }
    static requestApiAccessClicked() {
        (0,dist/* event */.B)("request_api_access", {
            category: "Fake_Doors",
            action: "request_api_access"
        });
    }
    static selectStrategyClicked(strategy) {
        (0,dist/* event */.B)("select_strategy", {
            category: "General",
            action: "select_strategy",
            label: strategy._id
        });
    }
}

;// CONCATENATED MODULE: ./components/filter/FilterByBaseAssetComponent.tsx







const FilterByBaseAssetComponent = ()=>{
    var _strategies_strategies, _strategies_strategies_items;
    const { skip , limit , baseAssetFilter , setBaseAssetFilter  } = useProtocolsStore((state)=>({
            skip: state.skip,
            limit: state.limit,
            baseAssetFilter: state.baseAssetFilter,
            setBaseAssetFilter: state.setBaseAssetFilter
        }));
    const { data: strategies  } = useInvestmentsData(skip, limit);
    const posthogInstance = (0,esm/* usePostHog */.U0)();
    const pool = strategies === null || strategies === void 0 ? void 0 : (_strategies_strategies = strategies.strategies) === null || _strategies_strategies === void 0 ? void 0 : (_strategies_strategies_items = _strategies_strategies.items) === null || _strategies_strategies_items === void 0 ? void 0 : _strategies_strategies_items.map((strategy)=>strategy.pool);
    const assets = pool === null || pool === void 0 ? void 0 : pool.filter((element, index)=>{
        return pool.indexOf(element) === index;
    });
    const options = assets === null || assets === void 0 ? void 0 : assets.reduce((a, strategy)=>(a.push({
            label: strategy,
            value: strategy
        }), a), [
        {
            label: "All",
            value: ""
        }
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownComponent, {
        title: "Base Asset",
        onChange: (e)=>{
            setBaseAssetFilter(e);
            PostHogUtils.selectedBaseAssetFilter(posthogInstance, e);
        },
        className: "flex flex-row items-center justify-center w-[167px] h-[35px] p-2 bg-[rgba(209,199,255,0.25)] text-center border-[rgba(255,255,255,0.1)] rounded-full text-white mr-2",
        options: options,
        value: baseAssetFilter
    });
};
/* harmony default export */ var filter_FilterByBaseAssetComponent = (FilterByBaseAssetComponent);

// EXTERNAL MODULE: ./node_modules/react-icons/fa/index.esm.js
var index_esm = __webpack_require__(9583);
;// CONCATENATED MODULE: ./components/filter/SearchProtocolComponent.tsx




const SearchProtocolComponent = ()=>{
    const setSearch = useProtocolsStore((state)=>state.setSearch);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-full flex flex-row mt-[6px] relative",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                className: "w-full h-[44px] text-[14px] rounded-[44px] bg-input-background text-[#C3BFD9] pl-[16px] pr-[16px] font-medium absolute",
                placeholder: "Search for a protocol...",
                type: "text",
                onChange: (e)=>{
                    setSearch(e.target.value);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaSearch */.U41, {
                size: 16,
                color: "white",
                className: "absolute right-5 top-3"
            })
        ]
    });
};
/* harmony default export */ var filter_SearchProtocolComponent = (SearchProtocolComponent);

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./components/ProtocolsComponent.tsx











const ProtocolsComponent = (param)=>{
    let { items  } = param;
    const [sortColumn, setSortColumn] = react.useState(""); // Current sort column
    const [sortDirection, setSortDirection] = react.useState(""); // Current sort direction
    const { search , baseAssetFilter , selectedStrategyIds , skip , limit , setStrategiesId , unsetStrategiesId , isProtocolsOpen , setIsProtocolsOpen , unselectAll  } = useProtocolsStore((state)=>({
            search: state.search,
            baseAssetFilter: state.baseAssetFilter,
            selectedStrategyIds: state.selectedStrategyIds,
            skip: state.skip,
            limit: state.limit,
            setStrategiesId: state.setStrategiesId,
            unsetStrategiesId: state.unsetStrategiesId,
            isProtocolsOpen: state.isProtocolsOpen,
            setIsProtocolsOpen: state.setIsProtocolsOpen,
            unselectAll: state.unselectAll
        }));
    const { setShowModalProtocolsMobile  } = useModalsStore((state)=>({
            setShowModalProtocolsMobile: state.setShowModalProtocolsMobile
        }));
    const { data: strategies  } = useInvestmentsData(skip, limit);
    const posthogInstance = (0,esm/* usePostHog */.U0)();
    const filteredItems = items === null || items === void 0 ? void 0 : items.filter((item)=>{
        if (search === "") {
            return true;
        }
        const searchLowerCase = search.toLowerCase();
        if (item.company.toLowerCase().includes(searchLowerCase) || item.network.toLowerCase().includes(searchLowerCase) || item.product.toLowerCase().includes(searchLowerCase) || item.pool.toLowerCase().includes(searchLowerCase)) {
            return true;
        }
        return false;
    }).filter((item)=>{
        if (baseAssetFilter === "") {
            return true;
        }
        if (item.pool.toLowerCase() === baseAssetFilter.toLowerCase()) {
            return true;
        }
        return false;
    });
    const baseAssetImages = strategies && strategies.tokens.reduce(function(map, obj) {
        map[obj.address.toLowerCase()] = obj.imageUrl;
        return map;
    }, {});
    //
    // Table Filter
    //
    const headers = [
        {
            key: "pool",
            label: "BASE ASSET",
            onClick: ()=>handleSort("pool")
        },
        {
            key: "company",
            label: "PROTOCOL",
            onClick: ()=>handleSort("company")
        },
        {
            key: "network",
            label: "NETWORK",
            onClick: ()=>handleSort("network")
        },
        {
            key: "product",
            label: "PRODUCT",
            onClick: ()=>handleSort("product")
        }
    ];
    const handleSort = (column)=>{
        // If the same column is clicked again, reverse the sort direction
        if (column === sortColumn) {
            setSortDirection(sortDirection === "asc" ? "desc" : "asc");
        } else {
            // If a different column is clicked, set it as the new sort column and default to ascending order
            setSortColumn(column);
            setSortDirection("asc");
        }
    };
    // Apply sorting to the filteredItems array based on the current sortColumn and sortDirection
    const sortedItems = react.useMemo(()=>{
        if (sortColumn && sortDirection) {
            const compareFn = (a, b)=>{
                var _a_sortColumn;
                const valueA = (_a_sortColumn = a[sortColumn]) !== null && _a_sortColumn !== void 0 ? _a_sortColumn : "";
                var _b_sortColumn;
                const valueB = (_b_sortColumn = b[sortColumn]) !== null && _b_sortColumn !== void 0 ? _b_sortColumn : "";
                if (valueA < valueB) {
                    return sortDirection === "asc" ? -1 : 1;
                }
                if (valueA > valueB) {
                    return sortDirection === "asc" ? 1 : -1;
                }
                return 0;
            };
            return filteredItems.slice().sort(compareFn);
        }
        return filteredItems;
    }, [
        sortColumn,
        sortDirection,
        filteredItems
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "".concat(isProtocolsOpen ? "" : "xl:w-[450px] ", "  w-full flex flex-col top-0 xl:bg-transparent md:p-0 xl:mt-0 p-[16px] mt-[26px] "),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-full flex flex-row justify-end pl-[15px] pr-3",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: "/assets/close_protocols.svg",
                        alt: "close protocols",
                        width: 26,
                        height: 26,
                        className: "cursor-pointer xl:hidden",
                        onClick: ()=>setShowModalProtocolsMobile(false)
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-full flex flex-row md:justify-center pl-[15px] pr-3",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat(isProtocolsOpen ? "md:justify-between  " : "md:justify-start ", " justify-start flex md:w-[1000px] md:flex-row md:items-center"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[25px] font-bold text-white",
                                children: "Protocols"
                            }),
                            isProtocolsOpen && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "text-[16px] text-title hidden xl:block cursor-pointer",
                                onClick: ()=>setIsProtocolsOpen(false),
                                children: [
                                    "<",
                                    " Hide"
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-full flex flex-row justify-center mt-[14px] pl-[15px]",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-[1000px] flex flex-col",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-[14px] font-medium text-[#C3BFD9]",
                            children: !isProtocolsOpen ? "Select below the strategies " : "Select below the strategies you want to compare realized returns of"
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "w-full h-[598px] xl:h-[594px] top-0 z-[60] xl:z-10 left-0 container-background rounded-[16px] mt-[17px] p-[16px] flex flex-col",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-row mt-[4px]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(filter_FilterByBaseAssetComponent, {}),
                                selectedStrategyIds.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "w-full flex flex-row justify-end text-[12px] font-bold text-[#AF9AFF] mt-[22px] ",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        onClick: ()=>{
                                            unselectAll();
                                            PostHogUtils.unselectedAllStrategies(posthogInstance);
                                        },
                                        className: "cursor-pointer hover:underline",
                                        children: [
                                            " ",
                                            "Clear selections"
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(filter_SearchProtocolComponent, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "grid grid-cols-4 mt-[52px] w-full",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-start-1 col-end-5 grid grid-cols-4 pl-[15px] rounded-[8px] h-[35px] text-[#D7D3EA] text-[10px] md:text-[14px] items-center bg-[#5c5776] w-full",
                                children: headers.map((header, index)=>{
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "text-center  flex flex-row items-center cursor-pointer ",
                                        onClick: ()=>{
                                            header.onClick();
                                        },
                                        children: [
                                            header.label,
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: sortDirection === "asc" && sortColumn === header.key ? "/assets/sort-asc.svg" : "/assets/sort-desc.svg",
                                                alt: "sort",
                                                width: 10,
                                                height: 10,
                                                className: "ml-[8px] cursor-pointer"
                                            })
                                        ]
                                    }, "protocol-item-table-header-".concat(index));
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "z-[61] h-[409px] mt-[4px] overflow-y-scroll scrollbar ",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "grid w-full grid-cols-4 gap-1",
                                children: sortedItems.map((strategy, index)=>{
                                    const isSelect = selectedStrategyIds === null || selectedStrategyIds === void 0 ? void 0 : selectedStrategyIds.includes(strategy._id);
                                    var _baseAssetImages_strategy_defaultBaseToken_toLowerCase;
                                    const image = (_baseAssetImages_strategy_defaultBaseToken_toLowerCase = baseAssetImages === null || baseAssetImages === void 0 ? void 0 : baseAssetImages[strategy.defaultBaseToken.toLowerCase()]) !== null && _baseAssetImages_strategy_defaultBaseToken_toLowerCase !== void 0 ? _baseAssetImages_strategy_defaultBaseToken_toLowerCase : "";
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "".concat(isSelect && "selected-protocol", " hover:selected-protocol col-start-1 col-end-5 h-[47px] text-white text-[14px] rounded-[8px] grid grid-cols-4 cursor-pointer "),
                                        onClick: ()=>{
                                            GoogleAnalytics.selectStrategyClicked(strategy);
                                            if (selectedStrategyIds.includes(strategy._id)) {
                                                unsetStrategiesId(strategy._id);
                                                PostHogUtils.unselectedStrategy(posthogInstance, strategy, selectedStrategyIds, strategies, "table");
                                            } else {
                                                setStrategiesId(strategy._id);
                                                PostHogUtils.selectedStrategy(posthogInstance, strategy, selectedStrategyIds, strategies, "table");
                                            }
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex flex-row items-center pl-[17px]",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        loader: (param)=>{
                                                            let { src  } = param;
                                                            return src;
                                                        },
                                                        src: image,
                                                        alt: "base asset",
                                                        width: 22,
                                                        height: 22,
                                                        className: "h-[22px] w-[22px] relative border-2 border-white rounded-full shadow-md z-10"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "w-[100px] ml-2 font-medium text-white truncate",
                                                        children: strategy.pool
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "flex items-center",
                                                children: strategy.company
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "flex items-center",
                                                children: strategy.network
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "flex items-center truncate",
                                                children: strategy.product
                                            })
                                        ]
                                    }, "protocol-item-table-".concat(index));
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var components_ProtocolsComponent = (ProtocolsComponent);

;// CONCATENATED MODULE: ./components/notifications/ApiErrorComponent.tsx


const ApiErrorComponent = (param)=>{
    let { error , refetch  } = param;
    react.useEffect(()=>{
        console.log("error", error);
    }, [
        error
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col items-center justify-center w-full",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-2xl font-bold",
                children: "Oops... something went wrong"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-lg font-bold",
                children: error
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: "px-4 py-2 mt-4 font-bold text-white bg-blue-500 rounded",
                onClick: ()=>{
                    refetch();
                },
                children: "Try again"
            })
        ]
    });
};
/* harmony default export */ var notifications_ApiErrorComponent = (ApiErrorComponent);

;// CONCATENATED MODULE: ./components/notifications/NoDataFound.tsx


const NoDataFound = (param)=>{
    let { message  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex items-center justify-center h-screen",
        children: message
    });
};
/* harmony default export */ var notifications_NoDataFound = (NoDataFound);

;// CONCATENATED MODULE: ./components/ProtocolsComponentDialog.tsx









function ProtocolsComponentDialog() {
    var _strategies_strategies;
    const { showModalProtocolsMobile , setShowModalProtocolsMobile  } = useModalsStore((state)=>({
            showModalProtocolsMobile: state.showModalProtocolsMobile,
            setShowModalProtocolsMobile: state.setShowModalProtocolsMobile
        }));
    const { skip , limit  } = useProtocolsStore((state)=>({
            skip: state.skip,
            limit: state.limit
        }));
    const { data: strategies , isLoading: isLoadingInvestments , isError: isErrorProtocols , error: errorProtocols , refetch: refetchProtocols  } = useInvestmentsData(skip, limit);
    react.useEffect(()=>{
        const close = (e)=>{
            if (e.keyCode === 27) {
                setShowModalProtocolsMobile(false);
            }
        };
        window.addEventListener("keydown", close);
        return ()=>window.removeEventListener("keydown", close);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: showModalProtocolsMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "fixed inset-0 z-[60] justify-center xl:hidden overflow-x-hidden overflow-y-auto outline-none flex bg-background focus:outline-none",
                onClick: (e)=>{
                    if (e.target === e.currentTarget) setShowModalProtocolsMobile(false);
                },
                children: isLoadingInvestments ? /*#__PURE__*/ (0,jsx_runtime.jsx)(notifications_LoadingComponent, {}) : isErrorProtocols ? /*#__PURE__*/ (0,jsx_runtime.jsx)(notifications_ApiErrorComponent, {
                    error: errorProtocols === null || errorProtocols === void 0 ? void 0 : errorProtocols.toString(),
                    refetch: refetchProtocols
                }) : strategies.strategies.count > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ProtocolsComponent, {
                    items: strategies === null || strategies === void 0 ? void 0 : (_strategies_strategies = strategies.strategies) === null || _strategies_strategies === void 0 ? void 0 : _strategies_strategies.items
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(notifications_NoDataFound, {
                    message: "No protocols found."
                })
            })
        }) : null
    });
}
/* harmony default export */ var components_ProtocolsComponentDialog = (ProtocolsComponentDialog);

;// CONCATENATED MODULE: ./queries/request-access/index.ts


async function requestAccess(ctx) {
    const [, text] = ctx.queryKey;
    if (text) {
        const { data  } = await services_api.post("/fake-door?email=".concat(text));
        return data;
    } else {
        return null;
    }
}
function useRequestAccess(text) {
    return (0,useQuery/* useQuery */.a)([
        "requestAccess",
        text
    ], requestAccess);
}

;// CONCATENATED MODULE: ./components/RequestAccessDialog.tsx







function RequestAccessDialog() {
    const { showModalRequestAccess , setShowModalRequestAccess  } = useModalsStore((state)=>({
            showModalRequestAccess: state.showModalRequestAccess,
            setShowModalRequestAccess: state.setShowModalRequestAccess
        }));
    const [email, setEmail] = react.useState();
    react.useEffect(()=>{
        const close = (e)=>{
            if (e.keyCode === 27) {
                setShowModalRequestAccess(false);
            }
        };
        window.addEventListener("keydown", close);
        return ()=>window.removeEventListener("keydown", close);
    }, []);
    const { error , isError , data , isLoading , refetch , isSuccess  } = useRequestAccess(email);
    react.useEffect(()=>{
        if (isSuccess && data) {
            (0,react_toastify_esm/* toast */.Am)("Request sent successfully!", {
                toastId: "request-api-access",
                type: "success"
            });
            setShowModalRequestAccess(false);
        }
    }, [
        data,
        isSuccess
    ]);
    function handleSubmit(e) {
        e.preventDefault();
        const target = e.target;
        const email = target.email.value;
        setEmail(email);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: showModalRequestAccess ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "fixed inset-0 z-50 flex items-center justify-center overflow-x-hidden overflow-y-auto outline-none focus:outline-none",
                    onClick: (e)=>{
                        if (e.target === e.currentTarget) setShowModalRequestAccess(false);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "relative w-full m-6 max-w-3xl md:w-[420px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "relative flex flex-col w-full h-[300px] border-0 rounded-lg shadow-lg outline-none container-background-dialog focus:outline-none",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex items-start justify-between p-5 border-b border-solid rounded-t",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            className: "text-3xl font-semibold text-title",
                                            children: "Request Access"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            className: "float-right p-1 ml-auto text-3xl font-semibold leading-none text-black bg-transparent border-0 outline-none opacity-5 focus:outline-none",
                                            onClick: ()=>setShowModalRequestAccess(false),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "block w-6 h-6 text-2xl text-black bg-transparent outline-none opacity-5 focus:outline-none",
                                                children: "\xd7"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "relative flex-auto",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                                        onSubmit: handleSubmit,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "p-4 text-body",
                                                children: "This feature is still not available. But you can leave your email address to receive a notification when this feature becomes available."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "flex flex-col items-center justify-center m-3 mb-6",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "flex flex-row items-center justify-center w-full p-1",
                                                    children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(notifications_LoadingComponent, {
                                                        message: "Sending..."
                                                    }) : isError ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "text-black",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(notifications_ApiErrorComponent, {
                                                            error: error === null || error === void 0 ? void 0 : error.toString(),
                                                            refetch: refetch
                                                        })
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "relative flex flex-row w-full",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                className: "w-full h-[44px] text-[13px] rounded-[44px] bg-input-background text-[#C3BFD9] pl-[16px] pr-[16px] font-medium absolute",
                                                                placeholder: "Email",
                                                                id: "email",
                                                                name: "email",
                                                                type: "email"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                className: "w-[65px] h-[27px] text-[10px] rounded-[44px] border-2 border-[#AF9AFF] text-[#AF9AFF] font-thin absolute right-[7px] top-[9px]",
                                                                disabled: isLoading,
                                                                type: "submit",
                                                                children: "SEND"
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "fixed inset-0 z-40 bg-black opacity-50",
                    onClick: ()=>setShowModalRequestAccess(false)
                })
            ]
        }) : null
    });
}
/* harmony default export */ var components_RequestAccessDialog = (RequestAccessDialog);

// EXTERNAL MODULE: ./node_modules/react-datepicker/dist/react-datepicker.min.js
var react_datepicker_min = __webpack_require__(9198);
var react_datepicker_min_default = /*#__PURE__*/__webpack_require__.n(react_datepicker_min);
// EXTERNAL MODULE: ./node_modules/react-datepicker/dist/react-datepicker.css
var react_datepicker = __webpack_require__(3300);
;// CONCATENATED MODULE: ./components/SelectStartEndDateDialog.tsx







function SelectStartEndDateDialog() {
    const { showModalDatePicker , setShowModalDatePicker  } = useModalsStore((state)=>({
            showModalDatePicker: state.showModalDatePicker,
            setShowModalDatePicker: state.setShowModalDatePicker
        }));
    const { startDate: startDateStore , setStartDate , setEndDate , setGranularity  } = useHistoricalStore((state)=>({
            startDate: state.startDate,
            setStartDate: state.setStartDate,
            setEndDate: state.setEndDate,
            setGranularity: state.setGranularity
        }));
    const [startInput, setStartInput] = react.useState(startDateStore);
    const [endInput, setEndInput] = react.useState("");
    react.useEffect(()=>{
        const close = (e)=>{
            if (e.keyCode === 27) {
                setShowModalDatePicker(false);
            }
        };
        window.addEventListener("keydown", close);
        return ()=>window.removeEventListener("keydown", close);
    }, []);
    const untilNowSelected = endInput === "";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: showModalDatePicker ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "fixed inset-0 z-50 flex items-center justify-center overflow-x-hidden overflow-y-auto outline-none focus:outline-none",
                    onClick: (e)=>{
                        if (e.target === e.currentTarget) setShowModalDatePicker(false);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "relative w-auto max-w-3xl mx-auto my-6",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "relative flex flex-col w-full border-0 rounded-lg shadow-2xl outline-none container-background-dialog focus:outline-none",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex items-start justify-between p-5 border-b border-solid rounded-t",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            className: "text-3xl font-semibold text-white",
                                            children: "Select Start and End Date"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            className: "float-right p-1 ml-auto text-3xl font-semibold leading-none text-black bg-transparent border-0 outline-none opacity-5 focus:outline-none",
                                            onClick: ()=>setShowModalDatePicker(false),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "block w-6 h-6 text-2xl text-black bg-transparent outline-none opacity-5 focus:outline-none",
                                                children: "\xd7"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "relative flex-auto p-6",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "my-4 text-lg leading-relaxed text-body",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex flex-col",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "text-white text-1xl",
                                                    children: "Start Date"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((react_datepicker_min_default()), {
                                                    selected: new Date(startInput),
                                                    onChange: (date)=>date && setStartInput(date.toISOString().split("T")[0]),
                                                    className: "p-2 text-black bg-gray-400 border-2 rounded-md"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "mt-4 text-white text-1xl",
                                                    children: "End Date"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                            type: "checkbox",
                                                            defaultChecked: true,
                                                            onClick: ()=>{
                                                                if (untilNowSelected) {
                                                                    setEndInput(new Date().toISOString().split("T")[0]);
                                                                } else {
                                                                    setEndInput("");
                                                                }
                                                            },
                                                            className: "p-2 mb-1 border-2 rounded-md"
                                                        }),
                                                        "\xa0Until now"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((react_datepicker_min_default()), {
                                                    disabled: untilNowSelected,
                                                    selected: untilNowSelected ? new Date() : new Date(endInput),
                                                    className: untilNowSelected ? "border-2 p-2 rounded-md opacity-50 cursor-not-allowed " : "border-2 p-2 rounded-md text-black bg-gray-400",
                                                    onChange: (date)=>date && setEndInput(date.toISOString().split("T")[0])
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex items-center justify-end p-6 border-t rounded-b",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            className: "px-6 py-2 mb-1 mr-1 text-sm font-bold text-red-500 uppercase transition-all duration-150 ease-linear outline-none background-transparent focus:outline-none",
                                            type: "button",
                                            onClick: ()=>setShowModalDatePicker(false),
                                            children: "Close"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            className: "px-6 py-3 mr-1 text-sm font-bold text-white uppercase transition-all duration-150 ease-linear rounded outline-none focus:outline-none",
                                            type: "button",
                                            onClick: ()=>{
                                                setStartDate(startInput);
                                                setEndDate(endInput);
                                                setShowModalDatePicker(false);
                                                setGranularity("custom");
                                                GoogleAnalytics.granularityClicked("clicked '".concat(startInput, "' to '").concat(endInput, "'"));
                                            },
                                            children: "Save Changes"
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "fixed inset-0 z-40 bg-black opacity-50",
                    onClick: ()=>setShowModalDatePicker(false)
                })
            ]
        }) : null
    });
}
/* harmony default export */ var components_SelectStartEndDateDialog = (SelectStartEndDateDialog);

;// CONCATENATED MODULE: ./components/SelectedProtocolsComponent.tsx







const SelectedProtocolsComponent = ()=>{
    var _strategies_strategies;
    const { skip , limit , selectedStrategyIds , setStrategiesId , unsetStrategiesId  } = useProtocolsStore((state)=>({
            skip: state.skip,
            limit: state.limit,
            selectedStrategyIds: state.selectedStrategyIds,
            setStrategiesId: state.setStrategiesId,
            unsetStrategiesId: state.unsetStrategiesId
        }));
    const { data: strategies  } = useInvestmentsData(skip, limit);
    const posthogInstance = (0,esm/* usePostHog */.U0)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex flex-row flex-nowrap w-full scrollbar mt-[20px] gap-[10px] xl:items-center overflow-x-auto overflow-y-hidden pb-3",
        children: strategies === null || strategies === void 0 ? void 0 : (_strategies_strategies = strategies.strategies) === null || _strategies_strategies === void 0 ? void 0 : _strategies_strategies.items.map((strategy, strategyIndex)=>{
            const isSelect = selectedStrategyIds === null || selectedStrategyIds === void 0 ? void 0 : selectedStrategyIds.includes(strategy._id);
            var _highContrastColors_strategyIndex;
            const color = (_highContrastColors_strategyIndex = highContrastColors[strategyIndex]) !== null && _highContrastColors_strategyIndex !== void 0 ? _highContrastColors_strategyIndex : "#fff";
            const rgbColor = hexToRGB(color, "0.25");
            if (!isSelect) return null;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-row w-auto items-center justify-center p-2 h-[24px] text-center border-[rgba(255,255,255,0.1)] rounded-full ",
                style: {
                    backgroundColor: rgbColor
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-[14px] font-bold mt-[1px]",
                        style: {
                            color: color,
                            whiteSpace: "nowrap"
                        },
                        children: (strategy === null || strategy === void 0 ? void 0 : strategy.pool) + " - " + (strategy === null || strategy === void 0 ? void 0 : strategy.company)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-[12px] ml-[9px] cursor-pointer ",
                        onClick: ()=>{
                            if (selectedStrategyIds.includes(strategy._id)) {
                                unsetStrategiesId(strategy._id);
                                PostHogUtils.unselectedStrategy(posthogInstance, strategy, selectedStrategyIds, strategies, "table");
                            } else {
                                setStrategiesId(strategy._id);
                                PostHogUtils.selectedStrategy(posthogInstance, strategy, selectedStrategyIds, strategies, "table");
                            }
                        },
                        style: {
                            color: color
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "13",
                            height: "13",
                            viewBox: "0 0 13 13",
                            fill: "none",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M6.00001 4.58579L9.29292 1.29288C9.68342 0.902377 10.3166 0.902377 10.7071 1.29288C11.0976 1.68338 11.0976 2.31658 10.7071 2.70708L7.4142 6.00001L10.7071 9.29292C11.0976 9.68342 11.0976 10.3166 10.7071 10.7071C10.3166 11.0976 9.68342 11.0976 9.29292 10.7071L6.00001 7.4142L2.7071 10.7071C2.3166 11.0976 1.6834 11.0976 1.2929 10.7071C0.902398 10.3166 0.902398 9.68342 1.2929 9.29292L4.58581 6.00001L1.2929 2.70708C0.902398 2.31658 0.902398 1.68338 1.2929 1.29288C1.6834 0.902377 2.3166 0.902377 2.7071 1.29288L6.00001 4.58579Z",
                                fill: color
                            })
                        })
                    })
                ]
            }, strategy._id);
        })
    });
};

;// CONCATENATED MODULE: ./components/VerifiedBySection.tsx




// aave, brahma, harvest, instadapp, opyn
const VerifiedBySection = (param)=>{
    let { started  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat(started ? "opacity-100 translate-y-4" : "opacity-0", " hidden md:flex flex-col mt-[68px] w-full transition-all duration-1000 delay-1000"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-row w-full justify-center items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaRegCheckSquare */.UUc, {
                        className: "w-[16px] h-[16px] accent-title bg-background checked:bg-title text-title rounded-[4px]"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "font-bold text-[16px] text-[#9377FF] pl-[10px]",
                        children: "Verified By"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-row md:gap-[25px] xl:gap-[63px] justify-center mt-[30px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        className: "flex flex-row justify-center items-center gap-[20px] mt-[20px]",
                        target: "_blank",
                        href: "https://aave.com/",
                        rel: "noreferrer",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: "/assets/aave-icon.svg",
                                width: 29,
                                height: 29,
                                alt: "aave"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: "/assets/aave-text.svg",
                                width: 85,
                                height: 23,
                                alt: "aave"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: "flex flex-row justify-center items-center gap-[20px] mt-[20px]",
                        target: "_blank",
                        href: "https://www.brahma.fi/",
                        rel: "noreferrer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "/assets/brahma-logo-dark.svg",
                            width: 146,
                            height: 41,
                            alt: "brahma"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: "flex flex-row justify-center items-center gap-[20px] mt-[20px]",
                        target: "_blank",
                        href: "https://www.harvest.finance/",
                        rel: "noreferrer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "/assets/harvest-standard.svg",
                            width: 146,
                            height: 41,
                            alt: "harvest"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: "flex flex-row justify-center items-center gap-[20px] mt-[20px]",
                        target: "_blank",
                        href: "https://instadapp.io/",
                        rel: "noreferrer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "/assets/instadapp-logo-dark.svg",
                            width: 146,
                            height: 41,
                            alt: "instadapp"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: "flex flex-row justify-center items-center gap-[0px] mt-[20px]",
                        target: "_blank",
                        href: "https://www.opyn.co/",
                        rel: "noreferrer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "/assets/opyn-logo.png",
                            width: 70,
                            height: 41,
                            alt: "opyn"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_VerifiedBySection = (VerifiedBySection);

;// CONCATENATED MODULE: ./components/navigation/Footer.tsx



const Footer = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "bg-[#1F1C30] p-4 mt-[48px] w-full",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: "https://www.pods.finance/",
                target: "_blank",
                rel: "noreferrer",
                className: "flex flex-row justify-center py-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-row items-center justify-center w-full",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "/assets/logo.svg",
                            width: 34,
                            height: 34,
                            alt: "logo"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-[17px] text-white font-extrabold ml-[16px] relative bottom-[-8px]",
                            children: "Defi Returns"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-row justify-center items-center mt-[36px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "/assets/disclaimer.pdf",
                        target: "_blank",
                        rel: "noreferrer",
                        className: "py-1 ml-4 text-white hover:underline",
                        children: "Disclaimer"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "ml-4 border-r-[1px] border-white h-[16px]"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "/assets/privacy-policy.pdf",
                        target: "_blank",
                        rel: "noreferrer",
                        className: "py-1 ml-4 text-white hover:underline",
                        children: "Privacy Policy"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "container mx-auto gap-2 flex flex-wrap md:flex-row items-center justify-center p-4 mt-[52px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        href: "https://twitter.com/DefiReturns",
                        target: "_blank",
                        rel: "noreferrer",
                        className: "flex flex-col items-center justify-center text-white md:flex-row hover:text-gray-500",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaTwitter */.fWC, {
                                className: "mr-2 w-[25px] h-[25px]"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "hidden md:block text-[#C3BFD9]",
                                children: "Twitter"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        href: "https://github.com/pods-finance",
                        target: "_blank",
                        rel: "noreferrer",
                        className: "flex flex-col items-center justify-center ml-4 text-white md:flex-row hover:text-gray-500 md:ml-8",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaGithub */.hJX, {
                                className: "mr-2 w-[25px] h-[25px]"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "hidden md:block text-[#C3BFD9]",
                                children: "Github"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        href: "https://discord.com/invite/Qf7utym",
                        target: "_blank",
                        rel: "noreferrer",
                        className: "flex flex-col items-center justify-center ml-4 text-white md:flex-row hover:text-gray-500 md:ml-8",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaDiscord */.j2d, {
                                className: "mr-2 w-[25px] h-[25px]"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "hidden md:block text-[#C3BFD9]",
                                children: "Discord"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        href: "https://www.youtube.com/c/PodsFinance",
                        target: "_blank",
                        rel: "noreferrer",
                        className: "flex flex-col items-center justify-center ml-4 text-white md:flex-row hover:text-gray-500 md:ml-8",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaYoutube */.V2E, {
                                className: "mr-2 w-[25px] h-[25px]"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "hidden md:block text-[#C3BFD9]",
                                children: "Youtube"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        href: "https://blog.pods.finance/",
                        target: "_blank",
                        rel: "noreferrer",
                        className: "flex flex-col items-center justify-center ml-4 text-white md:flex-row hover:text-gray-500 md:ml-8",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaMedium */.Vlo, {
                                className: "mr-2 w-[25px] h-[25px]"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "hidden md:block text-[#C3BFD9]",
                                children: "Medium"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var navigation_Footer = (Footer);

;// CONCATENATED MODULE: ./queries/newsletter/index.ts


async function subscribeNewsletter(ctx) {
    const [, email] = ctx.queryKey;
    if (!email) return null;
    const { data  } = await axios/* default.post */.Z.post("https://svaz36lzc6.execute-api.us-east-1.amazonaws.com/post-mailchimp", {
        email
    });
    return data;
}
function useSubscribeNewsletter(email) {
    return (0,useQuery/* useQuery */.a)([
        "subscribeNewsletter",
        email
    ], subscribeNewsletter);
}

;// CONCATENATED MODULE: ./components/navigation/NewsletterComponent.tsx









const NewsletterComponent = ()=>{
    const [email, setEmail] = react.useState();
    const { data , isLoading , isError , isSuccess , error , refetch  } = useSubscribeNewsletter(email);
    const posthogInstance = (0,esm/* usePostHog */.U0)();
    function handleSubmit(e) {
        e.preventDefault();
        const target = e.target;
        const email = target.email.value;
        PostHogUtils.submittedToNewsletter(posthogInstance, email);
        setEmail(email);
    }
    react.useEffect(()=>{
        if (isSuccess && data) {
            (0,react_toastify_esm/* toast */.Am)("Email subscribed successfully!", {
                toastId: "subscribe-newsletter",
                type: "success"
            });
            PostHogUtils.submittedToNewsletterSuccess(posthogInstance);
        }
    }, [
        isSuccess
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
        onSubmit: handleSubmit,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "w-full flex flex-row mt-[21px] relative",
            children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(notifications_LoadingComponent, {
                message: "Subscribing...",
                inline: true
            }) : isError ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-black",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(notifications_ApiErrorComponent, {
                    error: error === null || error === void 0 ? void 0 : error.toString(),
                    refetch: refetch
                })
            }) : isSuccess && data ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-row items-center w-full mt-2 transition-all duration-200 delay-75 opacity-100",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: "/assets/newsletter-success.svg",
                        width: 42,
                        height: 42,
                        alt: "mailbox"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-[20px] text-[#D8D3ED] font-bold pl-[18px]",
                        children: "Thanks for subscribing!"
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        className: "w-full h-[44px] text-[13px] rounded-[44px] bg-input-background text-[#C3BFD9] pl-[16px] pr-[16px] font-medium absolute",
                        placeholder: "Email",
                        id: "email",
                        name: "email",
                        type: "email"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "w-[85px] h-[27px] text-[10px] rounded-[44px] border-2 border-[#AF9AFF] text-[#AF9AFF] font-thin absolute right-[7px] top-[9px]",
                        disabled: isLoading,
                        type: "submit",
                        children: "SUBSCRIBE"
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var navigation_NewsletterComponent = (NewsletterComponent);

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
;// CONCATENATED MODULE: ./pages/index.tsx





















const Home = (param)=>{
    let { strategies  } = param;
    var _strategies_strategies;
    const [started, setStarted] = react.useState(false);
    const router = (0,next_router.useRouter)();
    const { granularity , setGranularity , yieldType , setYieldType , startDateFormatted , endDateFormatted , setEndDate , setStartDate  } = useHistoricalStore((state)=>({
            granularity: state.granularity,
            setGranularity: state.setGranularity,
            yieldType: state.yieldType,
            setYieldType: state.setYieldType,
            startDateFormatted: state.startDateFormatted,
            endDateFormatted: state.endDateFormatted,
            setEndDate: state.setEndDate,
            setStartDate: state.setStartDate
        }));
    const { setShowModalDatePicker , setShowModalProtocolsMobile , setShowModalRequestAccess  } = useModalsStore((state)=>({
            setShowModalDatePicker: state.setShowModalDatePicker,
            setShowModalProtocolsMobile: state.setShowModalProtocolsMobile,
            setShowModalRequestAccess: state.setShowModalRequestAccess
        }));
    const { setStrategiesId , selectedStrategyIds , isProtocolsOpen , setIsProtocolsOpen  } = useProtocolsStore((state)=>({
            setStrategiesId: state.setStrategiesId,
            selectedStrategyIds: state.selectedStrategyIds,
            isProtocolsOpen: state.isProtocolsOpen,
            setIsProtocolsOpen: state.setIsProtocolsOpen
        }));
    const posthogInstance = (0,esm/* usePostHog */.U0)();
    // Set initial selected strategy PODS
    react.useEffect(()=>{
        if (strategies && strategies.strategies.items.length > 0) {
            var _strategies_strategies_items_find;
            var _strategies_strategies_items_find__id;
            setStrategiesId((_strategies_strategies_items_find__id = (_strategies_strategies_items_find = strategies.strategies.items.find((obj)=>obj.company === "Pods")) === null || _strategies_strategies_items_find === void 0 ? void 0 : _strategies_strategies_items_find._id) !== null && _strategies_strategies_items_find__id !== void 0 ? _strategies_strategies_items_find__id : "");
        }
    }, [
        strategies,
        setStrategiesId,
        strategies.strategies.items
    ]);
    // everytime the user select/deselect strategy, update the URL
    react.useEffect(()=>{
        if (!started) return;
        router.push({
            query: {
                protocols: selectedStrategyIds
            }
        }, undefined, {
            shallow: true
        });
    }, [
        selectedStrategyIds
    ]);
    // when the user access the page, it get the strategies from URL and update the state
    react.useEffect(()=>{
        if (!started) return;
        const { protocols =[]  } = router.query;
        const updatedSelectedStrategyIds = Array.isArray(protocols) ? protocols : [
            protocols
        ];
        // if the strategy from the URL doesn't exist, remove that from the list
        const strategyIds = strategies.strategies.items.map((strategy)=>strategy._id).filter((id)=>updatedSelectedStrategyIds.includes(id));
        // update the strategies on the state
        strategyIds.forEach((id)=>{
            setStrategiesId(id);
        });
    }, [
        started,
        router.query
    ]);
    react.useEffect(()=>{
        setStarted(true);
    }, []);
    // function handleGranularityChange(e: React.ChangeEvent<HTMLSelectElement>) {
    function handleGranularityChange(value) {
        // const value = e.target.value as Granularity;
        setGranularity(value);
        if (value === "custom") {
            setShowModalDatePicker(true);
            PostHogUtils.clickedOnDatePicker(posthogInstance, "dropdown custom");
            return;
        }
        const dateYYYYMMDD = new Date().toISOString().split("T")[0];
        setEndDate(dateYYYYMMDD);
        const dates = {
            "1month": 1,
            "6months": 6,
            "12months": 12,
            custom: 0,
            week: 0
        };
        const startDate = new Date();
        startDate.setMonth(startDate.getMonth() - dates[value]);
        setStartDate(startDate.toISOString().split("T")[0]);
        PostHogUtils.selectedGranularity(posthogInstance, value);
    }
    function handleRankingStrategyClick(id) {
        var _document_getElementById;
        setStrategiesId(id);
        const offsetTop = (_document_getElementById = document.getElementById("graph")) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.offsetTop;
        window.scroll({
            top: offsetTop,
            behavior: "smooth"
        });
    }
    const timeRange = startDateFormatted + " " + (endDateFormatted ? "to " + endDateFormatted : " until now");
    const faqData = [
        {
            question: "Where does the data come from?",
            answer: "All data displayed on DeFi Returns is sourced from the blockchain, except for the price data, which is obtained from DeFi Llama."
        },
        {
            question: "How do you calculate the returns?",
            answer: "We use custom integrations for each protocol, but they all follow the same principle: we calculate the value of a position for each day of the selected date range. For single-token strategies, we divide the current position by the initial position to determine the yield. For multi-token strategies, we divide the current position by the current value of the initial position, effectively comparing the strategy to a buy-and-hold strategy of the initial assets. This is sometimes referred to as Impermanent Loss."
        },
        {
            question: "What about strategies with rewards?",
            answer: "For strategies with rewards, you can choose to view the accumulated yield with or without rewards by clicking on the 'Yield' dropdown in the top right corner of the chart. The system calculates the number of reward tokens one would receive for an initial position and converts them to the Base Asset, allowing it to be added to the principal position."
        },
        {
            question: "Is there a cost to use DeFi Returns?",
            answer: "DeFi Returns as you see here is a free to access, but we have a paid API with smaller granularity. Our goal is to provide users with valuable insights and data about various DeFi strategies and protocols."
        },
        {
            question: "How can I suggest a new feature or report a bug?",
            answer: "We appreciate your feedback and suggestions. Please reach out to us through our discord or email us at defireturns@pods.finance to report bugs or suggest new features."
        },
        {
            question: "How can I add my project to DeFi Returns?",
            answer: "If you have a DeFi project you would like to see listed on DeFi Returns, please get in touch with us through our discord or email us at defireturns@pods.finance with the relevant information about your project."
        },
        {
            question: "Do you support different blockchain networks?",
            answer: "Yes, DeFi Returns supports data from multiple blockchain networks, including Ethereum, Polygon, Arbitrum, Optimism, and others. We are constantly working to expand our coverage and include more networks and protocols."
        },
        {
            question: "What is the purpose of DeFi Returns?",
            answer: "DeFi Returns aims to bring transparency to DeFi and provide users with comprehensive, reliable and up-to-date information on various DeFi strategies and protocols. Our platform allows users to easily compare and analyze the performance of different strategies, bringing the most reliable data source for historical yield on DeFi, helping them make more informed decisions when investing in the ecosystem."
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "bg-background md:flex md:flex-col md:justify-center md:items-center md:w-full",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col min-h-screen items-center md:mt-[36px] xl:p-0 p-[16px] md:w-full lg:max-w-[1281px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-row items-center justify-between w-full",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-row items-end content-end xl:w-full text-end",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: "/assets/logo.svg",
                                        width: 40,
                                        height: 40,
                                        alt: "logo"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-[17px] md:text-[25px] md:relative md:bottom-[-9px] text-white font-extrabold ml-[16px]",
                                        children: "DeFi Returns"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: "w-[167px] pt-1 h-[43px] text-[14px] mt-0 xl:mt-[20px] border-2 border-[#AF9AFF] text-[#AF9AFF] rounded-[43px] font-semibold text-center z-2 cursor-pointer hover:opacity-50",
                                onClick: ()=>{
                                    setShowModalRequestAccess(true);
                                    PostHogUtils.requestedAPIAccess(posthogInstance, "header");
                                },
                                children: "GET API ACCESS"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat(started ? "opacity-100 translate-y-4" : "opacity-0", "  text-[30px] xl:w-[1013px] md:text-[50px] md:text-[transparent] text-white font-[700] mt-[80px] ease-in text-center transition-opacity duration-1000 delay-75 hero-text"),
                        children: "Compare historical returns to maximize your earning potential"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_VerifiedBySection, {
                        started: started
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col md:flex-row md:justify-center xl:px-[0px] md:mt-[80px] w-full mt-[50px] gap-[20px] xl:gap-[25px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "".concat(started ? "opacity-100 translate-y-4" : "opacity-0", " w-full h-[180px] xl:w-[345px] container-background rounded-[16px] pl-[27px] pr-[30px] pt-[21px] pb-[25px] transition-opacity duration-1000 delay-[1200ms]"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-row w-full",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: "/assets/ethereum.svg",
                                                width: 16,
                                                height: 16,
                                                alt: "ether realized APY"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-[16px] font-bold text-title ml-[8px] truncate",
                                                title: "Ether Realized APY 30d",
                                                children: "Ether Realized APY 30d"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "w-full flex flex-col gap-[10px] mt-[19px]",
                                        children: strategies === null || strategies === void 0 ? void 0 : strategies.topEthStrategies// remove undefined
                                        .filter((x)=>x).map((ethStrategy, index)=>{
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex flex-row content-between w-full cursor-pointer",
                                                onClick: ()=>{
                                                    handleRankingStrategyClick(ethStrategy._id);
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "w-full gap-[10px] flex flex-row",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "text-[14px] text-white font-bold truncate",
                                                                children: ethStrategy.pool
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "text-[14px] text-[#C3BFD9] font-bold",
                                                                children: ethStrategy.company
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "text-[14px] text-[#C3BFD9] font-medium",
                                                                children: ethStrategy.network
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "returns",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "text-[14px] text-[#AF9AFF] font-semibold",
                                                            children: [
                                                                ethStrategy.apy.toFixed(2),
                                                                "%"
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }, "eth-top-" + index);
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "".concat(started ? "opacity-100 translate-y-4" : "opacity-0", " w-full h-[180px] xl:w-[345px] container-background  rounded-[16px] pl-[27px] pr-[30px] pt-[21px] pb-[25px] transition-opacity duration-1000 delay-[1400ms]"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-row w-full",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: "/assets/coin-stacks.svg",
                                                width: 16,
                                                height: 16,
                                                alt: "Stablecoins realized APY"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-[16px] font-bold text-title ml-[8px] truncate",
                                                title: "Stablecoins realized APY 30d",
                                                children: "Stablecoins realized APY 30d"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "w-full flex flex-col gap-[10px] mt-[19px]",
                                        children: strategies === null || strategies === void 0 ? void 0 : strategies.topStableStrategies// remove undefined
                                        .filter((x)=>x).map((stablecoin, index)=>{
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex flex-row content-between w-full cursor-pointer",
                                                onClick: ()=>{
                                                    handleRankingStrategyClick(stablecoin._id);
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "w-full gap-[10px] flex flex-row",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "text-[14px] text-white font-bold truncate",
                                                                children: stablecoin.pool
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "text-[14px] text-[#C3BFD9] font-bold",
                                                                children: stablecoin.company
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "text-[14px] text-[#C3BFD9] font-medium",
                                                                children: stablecoin.network
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "returns",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "text-[14px] text-[#AF9AFF] font-semibold",
                                                            children: [
                                                                stablecoin.apy.toFixed(2),
                                                                "%"
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }, "stablecoin-top-" + index);
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "".concat(started ? "opacity-100 translate-y-4" : "opacity-0", " w-full h-[180px] xl:w-[529px] container-background  rounded-[16px] pl-[25px] pr-[30px] pt-[21px] pb-[25px] transition-opacity duration-1000 delay-[1600ms]"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-row w-full",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: "/assets/newsletter.svg",
                                                width: 16,
                                                height: 16,
                                                alt: "Get our Newsletter"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-[16px] font-bold text-title ml-[8px]",
                                                children: "Get our Newsletter"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex mt-[7px] font-medium text-[#C3BFD9]",
                                        children: "Stay tune with the best opportunities"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(navigation_NewsletterComponent, {})
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        id: "graph",
                        className: "".concat(started ? "opacity-100 translate-y-4" : "opacity-0", " flex flex-row w-full transition-opacity duration-1000 delay-[1800ms] relative md:h-[826px]"),
                        children: [
                            strategies.strategies.count > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat(!isProtocolsOpen ? "md:z-10 shadow-protocols" : "md:z-0", "\n              hidden xl:flex xl:w-[536px] xl:left-0 xl:h-[auto] xl:mt-[85px] transition-all duration-500 xl:absolute \n            "),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ProtocolsComponent, {
                                            items: strategies === null || strategies === void 0 ? void 0 : (_strategies_strategies = strategies.strategies) === null || _strategies_strategies === void 0 ? void 0 : _strategies_strategies.items
                                        })
                                    }),
                                    !isProtocolsOpen && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        id: "show-button",
                                        className: "text-[16px] text-title hidden xl:block cursor-pointer md:pl-4 md:z-[9999] absolute top-0 left-[174px] xl:mt-[93px]",
                                        onClick: ()=>setIsProtocolsOpen(true),
                                        children: [
                                            "Show ",
                                            ">"
                                        ]
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(notifications_NoDataFound, {
                                message: "No protocols found."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "".concat(isProtocolsOpen ? "xl:w-[718px]" : "xl:w-[1028px]", " w-full flex flex-col mt-[85px] md:absolute md:z-[12] md:right-0 transition-all"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "md:pl-4",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-[25px] font-bold text-white",
                                                children: "Historical Returns"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-[#C3BFD9] font-medium text-[14px] mt-[7px] md:hidden",
                                                children: "Realized and historical returns are now available for your favorite DeFi strategy. Select the strategies and timeframes you want to compare."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-[#C3BFD9] font-medium text-[14px] mt-[14px] hidden md:block",
                                                children: "Realized and historical returns are now available for your favorite DeFi strategy."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "xl:hidden",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "w-full flex flex-row mt-[21px] gap-[10px] justify-center",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                className: "w-[236px] h-[42px] text-[14px] text-white rounded-[43px] bg-add-assets-button font-semibold flex justify-center items-center",
                                                onClick: ()=>{
                                                    setShowModalProtocolsMobile(true);
                                                    PostHogUtils.clickedToAddStrategiesPopup(posthogInstance);
                                                },
                                                children: "ADD ASSETS"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "w-full md:h-[594px] container-background-graph-expanded rounded-[16px] mt-[17px] p-[16px] flex flex-col ",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex flex-col md:flex-row md:justify-between",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "flex flex-row text-[15px] font-bold text-[#AF9AFF] cursor-pointer",
                                                        onClick: ()=>{
                                                            setShowModalDatePicker(true);
                                                            PostHogUtils.clickedOnDatePicker(posthogInstance, "Results for");
                                                        },
                                                        children: [
                                                            "Results for ",
                                                            timeRange
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "flex flex-row mt-[20px] md:mt-0",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownComponent, {
                                                                className: "flex flex-row text-center p-4 justify-center items-center md:w-[170px] h-[39px] bg-[rgba(209,199,255,0.25)] border-[rgba(255,255,255,0.1)] rounded-full text-white mr-2",
                                                                options: [
                                                                    {
                                                                        value: "Yield",
                                                                        label: "Yield"
                                                                    },
                                                                    {
                                                                        value: "Rewards",
                                                                        label: "Yield + Rewards"
                                                                    }
                                                                ],
                                                                onChange: (e)=>{
                                                                    setYieldType(e);
                                                                    PostHogUtils.selectedYieldType(posthogInstance, e);
                                                                },
                                                                value: yieldType
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownComponent, {
                                                                className: "flex flex-row items-center justify-center md:w-[125px] h-[39px] bg-[rgba(209,199,255,0.25)] text-center border-[rgba(255,255,255,0.1)] rounded-full text-white md:mr-2 p-4",
                                                                options: [
                                                                    {
                                                                        value: "1month",
                                                                        label: "1 Month"
                                                                    },
                                                                    {
                                                                        value: "6months",
                                                                        label: "6 Months"
                                                                    },
                                                                    {
                                                                        value: "12months",
                                                                        label: "12 Months"
                                                                    },
                                                                    {
                                                                        value: "custom",
                                                                        label: "Custom"
                                                                    }
                                                                ],
                                                                onChange: (e)=>{
                                                                    handleGranularityChange(e);
                                                                },
                                                                value: granularity
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "hidden w-full pb-4 md:block",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectedProtocolsComponent, {})
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "h-[500px] mt-[6px]",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_LineChart, {
                                                    strategies: strategies
                                                })
                                            }),
                                            selectedStrategyIds.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "flex flex-row justify-end text-[12px] font-bold text-[#AF9AFF] mt-[22px] md:hidden",
                                                children: "Clear selections"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "w-full md:hidden",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectedProtocolsComponent, {})
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat(started ? "opacity-100 translate-y-4" : "opacity-0", " transition-opacity duration-1000 delay-[2000ms]"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FAQ, {
                            faqData: faqData
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "w-full h-[293px] md:h-[354px] rounded-[16px] md:bg-full-access-api-desktop bg-full-access-api flex flex-col mt-[33px] pt-[57px] px-[50px] md:px-[77px] ",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-white text-[28px] md:w-[414px] md:text-[42px] font-semibold z-2",
                                children: "Get full Access to our API"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: "w-[141px] pt-1 h-[43px] text-[14px] mt-[30px] border-2 border-[#AF9AFF] text-[#AF9AFF] rounded-[43px] font-semibold text-center z-2 cursor-pointer hover:opacity-50",
                                onClick: ()=>{
                                    setShowModalRequestAccess(true);
                                    PostHogUtils.requestedAPIAccess(posthogInstance, "contact us");
                                },
                                children: "CONTACT US"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SelectStartEndDateDialog, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ProtocolsComponentDialog, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_RequestAccessDialog, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(navigation_Footer, {})
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var pages = (Home);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [445,885,698,921,774,888,179], function() { return __webpack_exec__(8312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);